export const SECTION_TYPES = {
  PRODUCT: "PRODUCT",
  RESTAURANT: "RESTAURANT",
  VIDEO: "VIDEO",
};
